export const GD_SEND_INITIAL = 'gd-send-initial';
export const GD_CHAT_READY = 'gd-chat-ready';
export const HOST_INITIAL_DEDUPE_MS = 1000;

export interface HostInitialIntent {
  task?: string;
  message?: string;
}

export const normalizeHostInitial = (value: unknown): HostInitialIntent | undefined => {
  if (!value || typeof value !== 'object') return undefined;
  const raw = value as { task?: unknown; message?: unknown };
  const task = typeof raw.task === 'string' ? raw.task.trim() : '';
  const message = typeof raw.message === 'string' ? raw.message.trim() : '';
  if (!task && !message) return undefined;
  return {
    ...(task ? { task } : {}),
    ...(message ? { message } : {})
  };
};

export const hostInitialKey = (intent: HostInitialIntent): string =>
  JSON.stringify({ task: intent.task ?? '', message: intent.message ?? '' });

export interface ParsedHostInitial {
  id: number;
  intent: HostInitialIntent;
}

export const parseHostInitialMessage = (data: unknown): ParsedHostInitial | null => {
  if (!data || typeof data !== 'object') return null;
  const message = data as { type?: unknown; id?: unknown; data?: unknown };
  if (message.type !== GD_SEND_INITIAL) return null;
  const intent = normalizeHostInitial(message.data);
  if (!intent) return null;
  const id = typeof message.id === 'number' && Number.isFinite(message.id) ? message.id : 0;
  return { id, intent };
};

export const findHostTaskFlow = <T extends { id: string }>(
  flows: readonly T[],
  taskId: string
): T | undefined => flows.find(flow => flow.id === taskId);

export const isHostInitialReady = (state: {
  isInitialized: boolean;
  messageCount: number;
  isAgentBusy: boolean;
  showEmailModal: boolean;
}): boolean =>
  state.isInitialized && state.messageCount > 0 && !state.isAgentBusy && !state.showEmailModal;
